const store = {
  state: {
    router: null,
    orderData: null,
    loginRedirect: null,
    userLocation: null,
    routePaths: [],
  },
};
export default store;
